<div class="block-page-title">
    <h2 class="page-title">Все курсы</h2>
</div>
<courses-list [privateCourse]="privateCourse"></courses-list>
<router-outlet></router-outlet>